import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { Editor, EditorState, RichUtils, convertToRaw, CompositeDecorator, ContentState, Entity } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import { stateFromHTML } from 'draft-js-import-html';
import striptags from 'striptags';

import PromptDialog from '../prompt';

import icBold from './icon-bold.png';
import icItalic from './icon-italic.png';
import icUnderline from './icon-underline.png';

import icList from './icon-list.png';

import icLink from './icon-link.png';
import icUnlink from './icon-unlink.png';

import icMail from './icon-mail.png';

import css from './wysiwyg.scss';

import { VALIDATE_URL, VALIDATE_EMAIL } from '../validate';

const DEFAULT_VALUE = '<p><br></p>';
const DEBUG = false;

const findLinkEntities = function findLinkEntities(contentBlock, callback) {
	contentBlock.findEntityRanges(
		(character) => {
			const entityKey = character.getEntity();
			return (
				entityKey !== null &&
				Entity.get(entityKey).getType() === 'LINK'
			);
		},
		callback
	);
}

const Link = (props) => {
	const { url } = Entity.get(props.entityKey).getData();
	return (
		<a href={url} onClick={(e) => e.preventDefault()}>
			{props.children}
		</a>
	);
};

const decorator = new CompositeDecorator([
	{
		strategy: findLinkEntities,
		component: Link,
	},
]);

export default class InputWysiwyg extends Component {
	static propTypes = {
		value: React.PropTypes.string.isRequired,
		placeholder: React.PropTypes.string,
		onChange: React.PropTypes.func.isRequired,
		hasLists: React.PropTypes.bool.isRequired,
		hasLinks: React.PropTypes.bool.isRequired,
		hasStyle: React.PropTypes.bool.isRequired,
	};

	static defaultProps = {
		value: '',
		placeholder: '',
		hasLists: true,
		hasLinks: true,
		hasStyle: true,
		onChange: function() {},
	};

	constructor(props) {
		super();

		this.state = {
			editorState: EditorState.createWithContent(stateFromHTML(props.value), decorator),
		};

		this.logState = () => {
			const content = this.state.editorState.getCurrentContent();
			console.log(this.value());
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.value !== this.props.value) {
			// console.log(nextProps.value);
			// console.log(stateFromHTML(nextProps.value));
			this.setState({
				...this.state,
				editorState: EditorState.push(this.state.editorState, stateFromHTML(nextProps.value)),
			});
		}

		// this.setState({
		// 	...this.state,
		// 	value: nextProps.value,
		// });
	}

	render() {
		let className = 'form-wysiwyg';
		const { editorState } = this.state;

		if (this.props.className) {
			className += ' ' + this.props.className;
		}

		//DEBUG && console.log('render: ' + this.internalValue);
		// DEBUG && console.log('render: ' + this.value());

		const styleButtonGroup = [
			{ title: 'Bold', style: 'BOLD', icon: icBold, onToggle: (cmd) => this.toggleInlineStyle(cmd) },
			{ title: 'Italic', style: 'ITALIC', icon: icItalic, onToggle: (cmd) => this.toggleInlineStyle(cmd) },
			{ title: 'Underline', style: 'UNDERLINE', icon: icUnderline, onToggle: (cmd) => this.toggleInlineStyle(cmd) },
		];

		const listButtonGroup = [
			{ title: 'List', style: 'unordered-list-item', icon: icList, onToggle: (cmd) => this.toggleBlockStyle(cmd) },
		];

		const linkButtonGroup = [
			{ title: 'Link', style: 'unordered-list-item', icon: icLink, onToggle: (cmd) => this._promptForLink(cmd) },
			{ title: 'Unlink', style: 'unordered-list-item', icon: icUnlink, onToggle: (cmd) => this._removeLink(cmd) },
		];

		const mailButtonGroup = [
			{ title: 'Mail to', style: 'unordered-list-item', icon: icMail, onToggle: (cmd) => this._promptForEmail(cmd) },
		];

		function blackStyleFn(contentBlock) {
			const type = contentBlock.getType();
			if (type === 'unstyled') {
				return 'paragraph';
			}
		}

		return (
			<div className={className}>
				<div className='form-wysiwyg__toolbar'>

					{this.props.hasStyle && (
						<div className='form-wysiwyg__toolbar__group'>
							{styleButtonGroup.map((item, i) => <InputWysiwygButton key={i} {...item} />)}
						</div>
					)}

					{this.props.hasLists && (
						<div className='form-wysiwyg__toolbar__group'>
							{listButtonGroup.map((item, i) => <InputWysiwygButton key={i} {...item} />)}
						</div>
					)}

					{this.props.hasLinks && (
						<div className='form-wysiwyg__toolbar__group'>
							<PromptDialog ref='linkprompt' />
							{linkButtonGroup.map((item, i) => <InputWysiwygButton key={i} {...item} />)}
						</div>
					)}

					{this.props.hasLinks && (
						<div className='form-wysiwyg__toolbar__group'>
							<PromptDialog ref='mailprompt' />
							{mailButtonGroup.map((item, i) => <InputWysiwygButton key={i} {...item} />)}
						</div>
					)}

				</div>

				{/*
					<div
						className='form-wysiwyg__content'
						contentEditable='true'
						ref='editor'
						dangerouslySetInnerHTML={{
							__html: this.value(),
						}}
						onInput={(e) => this.emitChange(e)}
						onFocus={(e) => this.onFocus(e)}
						onBlur={(e) => this.onBlur(e)}
						onPaste={(e) => this.onPaste(e)}
					/>
				*/}

				<div className='form-wysiwyg__content'>
					<Editor ref='editor' placeholder={this.props.placeholder} editorState={editorState} blockStyleFn={blackStyleFn} handleKeyCommand={(cmd) => this.handleKeyCommand(cmd)} onChange={(edState) => this.onChange(edState)} />
				</div>

				{(DEBUG) && (
					<input
						onClick={this.logState}
						type='button'
						value='Log State'
					/>
				)}
			</div>
		);
	}

	value() {
		if (this.state.editorState) {
			const content = this.state.editorState.getCurrentContent();
			let html = stateToHTML(content);

			html = html.replace(/<br>/gi, '<br/>');
			html = html.replace(/<ins>/gi, '<u>');
			html = html.replace(/<\/ins>/gi, '</u>');
			//html = html.replace(/<p>&nbsp;(?!&nbsp;)/gi, '<p>');
			html = striptags(html, ['p', 'ul', 'li', 'strong', 'em', 'b', 'i', 'u', 'a', 'br']);

			return html;
		}

		return DEFAULT_VALUE;
	}

	handleKeyCommand(command) {
		// console.log(command);
		const newState = RichUtils.handleKeyCommand(this.state.editorState, command);
		if (newState) {
			this.onChange(newState);
			return true;
		}
		return false;
	}

	onChange(editorState) {
		this.setState({
			...this.state,
			editorState,
		});

		this.props.onChange({
			target: {
				value: this.value(),
			},
		});
	}

	toggleInlineStyle(command, arg) {
		// console.log('INLINE:', command);
		this.onChange(RichUtils.toggleInlineStyle(this.state.editorState, command));
	}

	toggleBlockStyle(command, arg) {
		// console.log('BLOCK:', command);
		this.onChange(RichUtils.toggleBlockType(this.state.editorState, command));
	}

	_promptForLink() {
		const prompt = this.refs.linkprompt;
		const { editorState } = this.state;
		const selection = editorState.getSelection();
		const currentContent = editorState.getCurrentContent();
		const currentBlock = currentContent.getBlockForKey(selection.getStartKey())

		const start = selection.getStartOffset();
		const end = selection.getEndOffset();
		const selectedText = currentBlock.getText().slice(start, end);

		if (!selection.isCollapsed()) {
			prompt.prompt('Where would you like the link to go?', 'http://', [], selectedText)
			.then((value) => {
				if (value) {
					let newValue = value;

					if (value && !(
						value.indexOf('mailto:') === 0 ||
						value.indexOf('http://') === 0 ||
						value.indexOf('https://') === 0 ||
						value.indexOf('ftp://') === 0
					)) {
						newValue = 'http://' + value;
					}

					// console.log(newValue);
					this._confirmLink(newValue);
				}
			})
			.catch(() => {
				// restore selection
			});
		}
	}

	_promptForEmail() {
		const prompt = this.refs.linkprompt;
		const { editorState } = this.state;
		const selection = editorState.getSelection();
		const currentContent = editorState.getCurrentContent();
		const currentBlock = currentContent.getBlockForKey(selection.getStartKey())

		const start = selection.getStartOffset();
		const end = selection.getEndOffset();
		const selectedText = currentBlock.getText().slice(start, end);

		if (!selection.isCollapsed()) {
			prompt.prompt('Which email address would you like to link to?', 'mailto:', [], selectedText)
			.then((value) => {
				if (value) {
					let newValue = value;

					if (value && value.indexOf('mailto:') === -1) {
						newValue = 'mailto:' + value;
					}

					// console.log(newValue);
					this._confirmLink(newValue);
				}
			})
			.catch(() => {
				// restore selection
			});
		}
	}

	_confirmLink(urlValue) {
		const { editorState } = this.state;
		const entityKey = Entity.create('LINK', 'MUTABLE', { url: urlValue });
		this.setState({
			...this.state,
			editorState: RichUtils.toggleLink(
				editorState,
				editorState.getSelection(),
				entityKey
			),
		}, () => {
			setTimeout(() => this.refs.editor.focus(), 0);
		});
	}

	_removeLink() {
		const { editorState } = this.state;
		const selection = editorState.getSelection();
		if (!selection.isCollapsed()) {
			this.setState({
				...this.state,
				editorState: RichUtils.toggleLink(editorState, selection, null),
			});
		}
	}

	// addParagraphs(text) {
	// 	let newHtml = text;
	// 	const paraStart = /^(<p>)/;
	// 	// const paraEnd = /(<\/p>)$/;
	// 	// const firstPara = /(<p>){1}/;
	// 	// const lastPara = /<\/p>(?!.*<\/p>)/;
	// 	const paraPresent = /(<p>)/;
	// 	// const attrRegex = /(\s+)(\S+)=["']?((?:.(?!["']?\s+(?:\S+)=|[>"']))+.)["']?/gi;
	//
	// 	newHtml = striptags(newHtml, ['p', 'ul', 'li', 'strong', 'em', 'b', 'i', 'u', 'a', 'br']);
	//
	// 	if (!newHtml.match(paraPresent)) {
	// 		newHtml = `<p>${newHtml}</p>`;
	// 	} else if (!newHtml.match(paraStart)) {
	// 		const insertEndParaAt = newHtml.indexOf('<p>') || newHtml.length;
	//
	// 		const pt1 = newHtml.substr(0, insertEndParaAt);
	// 		const pt2 = newHtml.substr(insertEndParaAt, newHtml.length);
	// 		newHtml = `<p>${pt1}</p>${pt2}`;
	// 	}
	//
	// 	return newHtml;
	// }

	// emitChange(e) {
	// 	let newHtml = this.refs.editor.innerHTML;
	//
	// 	newHtml = this.addParagraphs(newHtml);
	//
	// 	this.internalValue = newHtml;
	// 	this.value = newHtml;
	//
	// 	if (!this.internalValue) {
	// 		// if empty insert default empty paragraph and fix selection else contentEditable starts making DIVs instead of paragraphs
	// 		this.refs.editor.innerHTML = DEFAULT_VALUE;
	// 		this.internalValue = DEFAULT_VALUE;
	//
	// 		const el = ReactDOM.findDOMNode(this.refs.editor);
	//
	// 		if (document.createRange && window.getSelection) {
	// 			const range = document.createRange();
	// 			const sel = window.getSelection();
	// 			range.setStart(el.childNodes[0], 0);
	// 			range.collapse(true);
	// 			sel.removeAllRanges();
	// 			sel.addRange(range);
	// 		} /* else if (document.selection && document.selection.createRange) {
	// 			// old IE not supported
	// 			// document.selection.createRange();
	// 		}*/
	// 	}
	//
		// this.props.onChange({
		// 	target: {
		// 		value: newHtml,
		// 	},
		// });
	//
	// 	DEBUG && console.log('change: ' + this.internalValue);
	// }

	// onFocus() {
	// 	if (this.props.placeholder && this.props.placeholder === this.internalValue) {
	// 		DEBUG && console.log('focus:clear');
	// 		this.internalValue = DEFAULT_VALUE;
	//
	// 		this.forceUpdate();
	// 	}
	// }
	//
	// onBlur() {
	// 	if (this.props.placeholder && DEFAULT_VALUE === this.internalValue) {
	// 		DEBUG && console.log('blur:placehold');
	// 		DEBUG && console.log(this.props.placeholder);
	//
	// 		this.internalValue = this.props.placeholder;
	//
	// 		this.forceUpdate();
	// 	}
	// }



}

class InputWysiwygButton extends Component {
	static propTypes = {
		style: PropTypes.string.isRequired,
		title: PropTypes.string,
		icon: PropTypes.oneOfType([
			PropTypes.object,
			PropTypes.bool,
		]),
		onToggle: PropTypes.func,
	};

	static defaultProps = {
		style: 'bold',
		title: '',
		icon: false,
		onToggle: () => {},
	};

	constructor(props) {
		super(props);
		this.onToggle = (e) => {
			e.preventDefault();
			this.props.onToggle(this.props.style);
		};
	}

	render() {
		return (
			<button tabIndex='-1' className='form-wysiwyg__toolbar__button' onMouseDown={this.onToggle} title={this.props.title}>
				{(!!this.props.icon) && (
					<img {...this.props.icon} alt='Bold' />
				) || (
					<span>{this.props.title}</span>
				)}
			</button>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/form/wysiwyg/wysiwyg.js
 **/